// Level-gated console logger. Konfigurierbar per setLevel().

type Level = "trace" | "debug" | "info" | "warn" | "error" | "fatal";
const ORDER: Level[] = ["trace", "debug", "info", "warn", "error", "fatal"];

class DebugLogger {
  private currentLevel: Level = "info";

  setLevel(level: Level): void {
    this.currentLevel = level;
  }

  trace(message: string, context?: unknown): void {
    if (this.shouldLog("trace")) console.log(`[TRACE] ${message}`, context ?? "");
  }
  debug(message: string, context?: unknown): void {
    if (this.shouldLog("debug")) console.log(`[DEBUG] ${message}`, context ?? "");
  }
  info(message: string, context?: unknown): void {
    if (this.shouldLog("info")) console.log(`[INFO] ${message}`, context ?? "");
  }
  warn(message: string, context?: unknown): void {
    if (this.shouldLog("warn")) console.warn(`[WARN] ${message}`, context ?? "");
  }
  error(message: string, context?: unknown): void {
    if (this.shouldLog("error")) console.error(`[ERROR] ${message}`, context ?? "");
  }

  private shouldLog(messageLevel: Level): boolean {
    return ORDER.indexOf(messageLevel) >= ORDER.indexOf(this.currentLevel);
  }
}

export const logger = new DebugLogger();
